module.exports = __webpack_public_path__ + "img/30000.7e571eb9.jpg";